"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _recompose = require("@hypnosphi/recompose");

var withVisibilityState = (0, _recompose.withState)('isDetailsMenuVisible', 'setDetailsMenuVisibility', false);
var withVisibilityHandler = (0, _recompose.withHandlers)({
  toggleDetailsMenuVisibility: function toggleDetailsMenuVisibility(_ref) {
    var setDetailsMenuVisibility = _ref.setDetailsMenuVisibility,
        isDetailsMenuVisible = _ref.isDetailsMenuVisible;
    return function () {
      return setDetailsMenuVisibility(!isDetailsMenuVisible);
    };
  },
  showDetailsMenu: function showDetailsMenu(_ref2) {
    var setDetailsMenuVisibility = _ref2.setDetailsMenuVisibility;
    return function () {
      return setDetailsMenuVisibility(true);
    };
  },
  hideDetailsMenu: function hideDetailsMenu(_ref3) {
    var setDetailsMenuVisibility = _ref3.setDetailsMenuVisibility;
    return function () {
      return setDetailsMenuVisibility(false);
    };
  },
  handleKeyDown: function handleKeyDown(_ref4) {
    var setDetailsMenuVisibility = _ref4.setDetailsMenuVisibility,
        isDetailsMenuVisible = _ref4.isDetailsMenuVisible;
    return function (event) {
      if (isDetailsMenuVisible && event.key === 'Escape') {
        setDetailsMenuVisibility(false);
        event.stopPropagation();
      }
    };
  }
});
var withDetailsMenuHandler = (0, _recompose.compose)(withVisibilityState, withVisibilityHandler);
var _default = withDetailsMenuHandler;
exports["default"] = _default;